export default __webpack_public_path__ + "static/media/Tea Ceremony-0532.ac943ba5.jpg";